const borderRadiusLarge = '12px';

export { borderRadiusLarge };
